// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.campaign-group-stats {
  margin-top: 2rem;
}

.section-title {
  margin: 1.5rem 0 1rem;
}

.summary-row {
  display: grid;
  gap: 1rem;
  margin-bottom: 1rem;
}

.summary-row--quad {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.summary-row--duo {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.finance-panel {
  border: 1px solid var(--surface-border, #dee2e6);
  border-radius: 8px;
  padding: 1rem 1.25rem;
  background: var(--surface-card, #fff);
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.finance-panel__title {
  margin: 0 0 0.25rem;
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--text-color, #212529);
}

.finance-panel__row {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 1rem;
  font-size: 0.9rem;
}

.finance-panel__row--total {
  margin-top: 0.25rem;
  padding-top: 0.5rem;
  border-top: 1px solid var(--surface-border, #dee2e6);
  font-weight: 600;
}

.finance-panel__label {
  color: var(--text-color-secondary, #6c757d);
}

.finance-panel__value {
  font-weight: 500;
  white-space: nowrap;
}

.finance-panel__hint {
  margin-top: 0.25rem;
  font-size: 0.8rem;
  color: var(--text-color-secondary, #6c757d);
}

.summary-cards {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 1rem;
}

.summary-card {
  border: 1px solid var(--surface-border, #dee2e6);
  border-radius: 8px;
  padding: 1rem;
  background: var(--surface-card, #fff);
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.summary-card__label {
  font-size: 0.85rem;
  color: var(--text-color-secondary, #6c757d);
}

.summary-card__value {
  font-size: 1.35rem;
  font-weight: 600;
}

.summary-card__value--small {
  font-size: 0.95rem;
  font-weight: 500;
}

.summary-card__hint {
  font-size: 0.8rem;
  color: var(--text-color-secondary, #6c757d);
}

.charts-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;
  margin: 1rem 0;
}

.charts-grid--triple {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.charts-grid--single {
  grid-template-columns: 1fr;
  margin-bottom: 2rem;
}

.chart-panel {
  border: 1px solid var(--surface-border, #dee2e6);
  border-radius: 8px;
  padding: 0.5rem;
  background: var(--surface-card, #fff);
}

.chart-panel--wide {
  grid-column: 1/-1;
}

.stats-loading {
  display: flex;
  justify-content: center;
  padding: 2rem;
}

.read-placeholder {
  margin-top: 1rem;
  color: var(--text-color-secondary, #6c757d);
}

.actions-col {
  width: 5.5rem;
  white-space: nowrap;
}

.campaign-expand-panel {
  padding: 1rem 1.25rem;
  background: var(--surface-ground, #f8f9fa);
  border-radius: 8px;
}

.expand-section-title {
  margin: 0 0 1rem;
  font-size: 1rem;
}

.expand-stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 1rem;
}

.expand-field {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.expand-field--full {
  grid-column: 1/-1;
}

.expand-field__label {
  font-size: 0.85rem;
  color: var(--text-color-secondary, #6c757d);
  font-weight: 600;
}

.spread-preview-note {
  margin: 0 0 1rem;
  padding: 0.5rem 0.75rem;
  border-left: 4px solid #3b82f6;
  background: #eff6ff;
  color: #1e40af;
  font-size: 0.9rem;
}

.detail-loading {
  display: flex;
  justify-content: center;
  padding: 1rem;
}

.detail-error {
  margin: 0;
  color: #c0392b;
}

.threshold-progress-field {
  margin-top: 0.5rem;
}

.threshold-progress-hint {
  margin: 0 0 0.75rem 0;
  color: #555;
  font-size: 0.95rem;
}

.threshold-progress-badge {
  display: inline-block;
  margin-left: 0.5rem;
  padding: 0.15rem 0.5rem;
  border-radius: 4px;
  background: #fdecea;
  color: #c0392b;
  font-size: 0.8rem;
  font-weight: 600;
}

.threshold-progress {
  max-width: 520px;
}

.threshold-progress__track {
  position: relative;
  height: 12px;
  border-radius: 6px;
  background: #e8ecef;
  overflow: visible;
}

.threshold-progress__fill {
  height: 100%;
  border-radius: 6px;
  background: linear-gradient(90deg, #3498db, #2980b9);
  transition: width 0.25s ease;
}

.threshold-progress__fill--warn {
  background: linear-gradient(90deg, #e67e22, #d35400);
}

.threshold-progress__marker {
  position: absolute;
  top: -4px;
  width: 3px;
  height: 20px;
  margin-left: -1.5px;
  border-radius: 1px;
  background: #2c3e50;
  box-shadow: 0 0 0 2px #fff;
  z-index: 1;
}

.threshold-progress__axis {
  display: flex;
  justify-content: space-between;
  margin-top: 0.35rem;
  font-size: 0.8rem;
  color: #7f8c8d;
}

@media (max-width: 900px) {
  .summary-row--quad,
  .summary-row--duo {
    grid-template-columns: 1fr;
  }
  .charts-grid,
  .charts-grid--triple {
    grid-template-columns: 1fr;
  }
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./projects/app-ui/src/app/admin/pages/marketing/campaign-group/campaign-group-stats/campaign-group-stats.component.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;AACJ;;AAEA;EACI,qBAAA;AACJ;;AAEA;EACI,aAAA;EACA,SAAA;EACA,mBAAA;AACJ;;AAEA;EACI,gDAAA;AACJ;;AAEA;EACI,gDAAA;AACJ;;AAEA;EACI,gDAAA;EACA,kBAAA;EACA,qBAAA;EACA,qCAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;AACJ;;AAEA;EACI,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iCAAA;AACJ;;AAEA;EACI,aAAA;EACA,8BAAA;EACA,qBAAA;EACA,SAAA;EACA,iBAAA;AACJ;;AAEA;EACI,mBAAA;EACA,mBAAA;EACA,oDAAA;EACA,gBAAA;AACJ;;AAEA;EACI,2CAAA;AACJ;;AAEA;EACI,gBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,mBAAA;EACA,iBAAA;EACA,2CAAA;AACJ;;AAEA;EACI,aAAA;EACA,4DAAA;EACA,SAAA;AACJ;;AAEA;EACI,gDAAA;EACA,kBAAA;EACA,aAAA;EACA,qCAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AACJ;;AAEA;EACI,kBAAA;EACA,2CAAA;AACJ;;AAEA;EACI,kBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,iBAAA;EACA,2CAAA;AACJ;;AAEA;EACI,aAAA;EACA,gDAAA;EACA,SAAA;EACA,cAAA;AACJ;;AAEA;EACI,gDAAA;AACJ;;AAEA;EACI,0BAAA;EACA,mBAAA;AACJ;;AAEA;EACI,gDAAA;EACA,kBAAA;EACA,eAAA;EACA,qCAAA;AACJ;;AAEA;EACI,iBAAA;AACJ;;AAEA;EACI,aAAA;EACA,uBAAA;EACA,aAAA;AACJ;;AAEA;EACI,gBAAA;EACA,2CAAA;AACJ;;AAEA;EACI,aAAA;EACA,mBAAA;AACJ;;AAEA;EACI,qBAAA;EACA,0CAAA;EACA,kBAAA;AACJ;;AAEA;EACI,gBAAA;EACA,eAAA;AACJ;;AAEA;EACI,aAAA;EACA,4DAAA;EACA,SAAA;AACJ;;AAEA;EACI,aAAA;EACA,sBAAA;EACA,YAAA;AACJ;;AAEA;EACI,iBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,2CAAA;EACA,gBAAA;AACJ;;AAEA;EACI,gBAAA;EACA,uBAAA;EACA,8BAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;AACJ;;AAEA;EACI,aAAA;EACA,uBAAA;EACA,aAAA;AACJ;;AAEA;EACI,SAAA;EACA,cAAA;AACJ;;AAEA;EACI,kBAAA;AACJ;;AAEA;EACI,qBAAA;EACA,WAAA;EACA,kBAAA;AACJ;;AAEA;EACI,qBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,gBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;AACJ;;AAEA;EACI,YAAA;EACA,kBAAA;EACA,oDAAA;EACA,4BAAA;AACJ;;AAEA;EACI,oDAAA;AACJ;;AAEA;EACI,kBAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,0BAAA;EACA,UAAA;AACJ;;AAEA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;AACJ;;AAEA;EACI;;IAEI,0BAAA;EACN;EAEE;;IAEI,0BAAA;EAAN;AACF;AACA,guTAAguT","sourcesContent":[".campaign-group-stats {\n    margin-top: 2rem;\n}\n\n.section-title {\n    margin: 1.5rem 0 1rem;\n}\n\n.summary-row {\n    display: grid;\n    gap: 1rem;\n    margin-bottom: 1rem;\n}\n\n.summary-row--quad {\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n}\n\n.summary-row--duo {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n\n.finance-panel {\n    border: 1px solid var(--surface-border, #dee2e6);\n    border-radius: 8px;\n    padding: 1rem 1.25rem;\n    background: var(--surface-card, #fff);\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n}\n\n.finance-panel__title {\n    margin: 0 0 0.25rem;\n    font-size: 0.95rem;\n    font-weight: 600;\n    color: var(--text-color, #212529);\n}\n\n.finance-panel__row {\n    display: flex;\n    justify-content: space-between;\n    align-items: baseline;\n    gap: 1rem;\n    font-size: 0.9rem;\n}\n\n.finance-panel__row--total {\n    margin-top: 0.25rem;\n    padding-top: 0.5rem;\n    border-top: 1px solid var(--surface-border, #dee2e6);\n    font-weight: 600;\n}\n\n.finance-panel__label {\n    color: var(--text-color-secondary, #6c757d);\n}\n\n.finance-panel__value {\n    font-weight: 500;\n    white-space: nowrap;\n}\n\n.finance-panel__hint {\n    margin-top: 0.25rem;\n    font-size: 0.8rem;\n    color: var(--text-color-secondary, #6c757d);\n}\n\n.summary-cards {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n    gap: 1rem;\n}\n\n.summary-card {\n    border: 1px solid var(--surface-border, #dee2e6);\n    border-radius: 8px;\n    padding: 1rem;\n    background: var(--surface-card, #fff);\n    display: flex;\n    flex-direction: column;\n    gap: 0.35rem;\n}\n\n.summary-card__label {\n    font-size: 0.85rem;\n    color: var(--text-color-secondary, #6c757d);\n}\n\n.summary-card__value {\n    font-size: 1.35rem;\n    font-weight: 600;\n}\n\n.summary-card__value--small {\n    font-size: 0.95rem;\n    font-weight: 500;\n}\n\n.summary-card__hint {\n    font-size: 0.8rem;\n    color: var(--text-color-secondary, #6c757d);\n}\n\n.charts-grid {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 1rem;\n    margin: 1rem 0;\n}\n\n.charts-grid--triple {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n\n.charts-grid--single {\n    grid-template-columns: 1fr;\n    margin-bottom: 2rem;\n}\n\n.chart-panel {\n    border: 1px solid var(--surface-border, #dee2e6);\n    border-radius: 8px;\n    padding: 0.5rem;\n    background: var(--surface-card, #fff);\n}\n\n.chart-panel--wide {\n    grid-column: 1 / -1;\n}\n\n.stats-loading {\n    display: flex;\n    justify-content: center;\n    padding: 2rem;\n}\n\n.read-placeholder {\n    margin-top: 1rem;\n    color: var(--text-color-secondary, #6c757d);\n}\n\n.actions-col {\n    width: 5.5rem;\n    white-space: nowrap;\n}\n\n.campaign-expand-panel {\n    padding: 1rem 1.25rem;\n    background: var(--surface-ground, #f8f9fa);\n    border-radius: 8px;\n}\n\n.expand-section-title {\n    margin: 0 0 1rem;\n    font-size: 1rem;\n}\n\n.expand-stats-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n    gap: 1rem;\n}\n\n.expand-field {\n    display: flex;\n    flex-direction: column;\n    gap: 0.25rem;\n}\n\n.expand-field--full {\n    grid-column: 1 / -1;\n}\n\n.expand-field__label {\n    font-size: 0.85rem;\n    color: var(--text-color-secondary, #6c757d);\n    font-weight: 600;\n}\n\n.spread-preview-note {\n    margin: 0 0 1rem;\n    padding: 0.5rem 0.75rem;\n    border-left: 4px solid #3b82f6;\n    background: #eff6ff;\n    color: #1e40af;\n    font-size: 0.9rem;\n}\n\n.detail-loading {\n    display: flex;\n    justify-content: center;\n    padding: 1rem;\n}\n\n.detail-error {\n    margin: 0;\n    color: #c0392b;\n}\n\n.threshold-progress-field {\n    margin-top: 0.5rem;\n}\n\n.threshold-progress-hint {\n    margin: 0 0 0.75rem 0;\n    color: #555;\n    font-size: 0.95rem;\n}\n\n.threshold-progress-badge {\n    display: inline-block;\n    margin-left: 0.5rem;\n    padding: 0.15rem 0.5rem;\n    border-radius: 4px;\n    background: #fdecea;\n    color: #c0392b;\n    font-size: 0.8rem;\n    font-weight: 600;\n}\n\n.threshold-progress {\n    max-width: 520px;\n}\n\n.threshold-progress__track {\n    position: relative;\n    height: 12px;\n    border-radius: 6px;\n    background: #e8ecef;\n    overflow: visible;\n}\n\n.threshold-progress__fill {\n    height: 100%;\n    border-radius: 6px;\n    background: linear-gradient(90deg, #3498db, #2980b9);\n    transition: width 0.25s ease;\n}\n\n.threshold-progress__fill--warn {\n    background: linear-gradient(90deg, #e67e22, #d35400);\n}\n\n.threshold-progress__marker {\n    position: absolute;\n    top: -4px;\n    width: 3px;\n    height: 20px;\n    margin-left: -1.5px;\n    border-radius: 1px;\n    background: #2c3e50;\n    box-shadow: 0 0 0 2px #fff;\n    z-index: 1;\n}\n\n.threshold-progress__axis {\n    display: flex;\n    justify-content: space-between;\n    margin-top: 0.35rem;\n    font-size: 0.8rem;\n    color: #7f8c8d;\n}\n\n@media (max-width: 900px) {\n    .summary-row--quad,\n    .summary-row--duo {\n        grid-template-columns: 1fr;\n    }\n\n    .charts-grid,\n    .charts-grid--triple {\n        grid-template-columns: 1fr;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
